import { Box, Snackbar, Alert } from "@mui/material";
import FloatingActionItems from "../../../pages/FloatingItems/FloatingActionItems";
import LeadsManagementTabs from "./LeadsManagementTabs";
import Leads from "./Leads/Leads";
import Analytics from "./Analytics/Analytics";
import { useLeadsManagementData } from "./hooks/useLeadsManagementData";

interface LeadsManagementProps {
  websiteSharedUid: string;
}

export default function LeadsManagement({
  websiteSharedUid,
}: LeadsManagementProps) {
  const leadsData = useLeadsManagementData(websiteSharedUid);

  return (
    <Box sx={{ px: 4, py: 3 }}>
      <Box sx={{ mb: 0.5 }}>
        <Box
          component="h1"
          sx={{ m: 0, fontSize: 30, fontWeight: 700, color: "#1a1a1a" }}
        >
          Leads Management
        </Box>
        <Box sx={{ mt: 0.75, fontSize: 15, color: "#757575" }}>
          Review acquired leads, their scoring and brand outcome, report them to
          their brand partner, and analyze acquisition trends.
        </Box>
      </Box>

      <LeadsManagementTabs
        view={leadsData.view}
        onChangeView={leadsData.setView}
      />

      {leadsData.view === "leads" ? (
        <Leads data={leadsData} />
      ) : (
        <Analytics data={leadsData} />
      )}

      <div data-tracker="940">
        <FloatingActionItems
          selectedSiteFloatingAction={websiteSharedUid}
          selectedDimensionsFloatingAction=""
          trackIdFloatingAction="941"
        />
      </div>

      <Snackbar
        open={!!leadsData.toastMessage}
        autoHideDuration={3400}
        onClose={leadsData.clearToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={leadsData.toastSeverity}
          onClose={leadsData.clearToast}
          sx={{ width: "100%" }}
        >
          {leadsData.toastMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
